export const AUTH = 'Auth'
